import axios from 'axios'

const client = axios.create({
  baseURL: import.meta.env.VITE_WP_API_URL,
  timeout: 12000,
  headers: { 'Content-Type': 'application/json' },
})

client.interceptors.response.use(
  (res) => res.data,
  (err) => {
    const message = err.response?.data?.message || err.message || 'Unknown API error'
    console.error('[Farafeero API]', message)
    return Promise.reject(new Error(message))
  }
)

export default client
